export const toDegrees = (radians: number) => radians * (180 / Math.PI);